import screenfull from 'screenfull'
import uiConfiguration from '../uiConfiguration'
import { AssetsService } from '@coosmo/shared-utils'
import { prepareViewerHomeResetOnNextResize, shouldResetHomeOnFullscreen } from './fullscreenHome'
import { restoreViewerCreditsVisibility, setViewerCreditsVisibility } from '../viewerCredits'

const fullPageIcon = AssetsService.getSvgIcon('full-screen.svg')
const fullPageExitIcon = AssetsService.getSvgIcon('full-screen-exit.svg')

function showLogoInFullscreen(customUIName) {
  return uiConfiguration.getConfigurationFor(customUIName, 'showLogoInFullScreen')
}

function hasInitialViewportFromUrl() {
  const urlParams = new URLSearchParams(window.location.search)
  return Boolean(urlParams.get('xywh') || (urlParams.get('zoom') && urlParams.get('x') && urlParams.get('y')))
}

function trackUserViewportAdjustments(viewer) {
  let hasUserAdjustedViewport = false
  const resetUserAdjustedViewport = () => (hasUserAdjustedViewport = false)
  const setUserAdjustedViewport = () => (hasUserAdjustedViewport = true)

  if (viewer && typeof viewer.addHandler === 'function') {
    viewer.addHandler('open', resetUserAdjustedViewport)
    viewer.addHandler('home', resetUserAdjustedViewport)
    ;['canvas-drag', 'canvas-scroll', 'canvas-double-click', 'canvas-pinch'].forEach(eventName => {
      viewer.addHandler(eventName, setUserAdjustedViewport)
    })
  }

  ;['zoom-in', 'zoom-out', 'navigator'].forEach(elementId => {
    const element = document.getElementById(elementId)
    if (!element) {
      return
    }

    ;['click', 'wheel', 'touchstart'].forEach(eventName => {
      element.addEventListener(eventName, setUserAdjustedViewport, { passive: true })
    })
  })

  return {
    hasUserAdjustedViewport: () => hasUserAdjustedViewport
  }
}

export function setupFullscreenButton(viewer, customUIName) {
  if (!screenfull.isEnabled) {
    return
  }
  let preparedHomeReset = null
  const userViewportAdjustments = trackUserViewportAdjustments(viewer)
  const hasInitialViewport = hasInitialViewportFromUrl()

  const resetHomeIfNeeded = () => {
    if (screenfull.isFullscreen && preparedHomeReset) {
      preparedHomeReset.forceResize()
    }
  }

  screenfull.on('change', () => {
    document.getElementById('full-page').classList.toggle('full-screen-active', screenfull.isFullscreen)
    if (screenfull.isFullscreen) {
      setViewerCreditsVisibility(showLogoInFullscreen(customUIName))
    } else {
      restoreViewerCreditsVisibility()
    }

    const fullScreenButton = document.querySelector(`#full-page > button`)
    if (screenfull.isFullscreen) {
      fullScreenButton.innerHTML = `<img src="${fullPageExitIcon}"/>`
    } else {
      fullScreenButton.innerHTML = `<img src="${fullPageIcon}"/>`
    }

    resetHomeIfNeeded()

    if (!screenfull.isFullscreen) {
      if (preparedHomeReset) {
        preparedHomeReset.cancel()
        preparedHomeReset = null
      }
    }
  })

  const fullScreenButton = document.getElementById('full-page')
  fullScreenButton.addEventListener('click', () => {
    if (screenfull.isEnabled) {
      if (preparedHomeReset) {
        preparedHomeReset.cancel()
        preparedHomeReset = null
      }

      const shouldResetHome =
        !screenfull.isFullscreen &&
        shouldResetHomeOnFullscreen(viewer, userViewportAdjustments.hasUserAdjustedViewport(), hasInitialViewport)

      if (shouldResetHome) {
        preparedHomeReset = prepareViewerHomeResetOnNextResize(viewer)
      }

      screenfull
        .toggle()
        .then(resetHomeIfNeeded)
        .catch(e => {
          if (preparedHomeReset) {
            preparedHomeReset.cancel()
            preparedHomeReset = null
          }
          console.warn(e)
        })
    }
  })
}
